export const ESIA_USIS_MODAL_STEPS = {
  MAIN: 'mainInfo',
  SERVICE_TIED: 'serviceTied',
  CONFIRM_DEACTIVATE: 'confirmDeactivate',
  internalSystemError: 'internalSystemError',
  esiaServerError: 'esiaServerError',
  refusePermissionByUser: 'refusePermissionByUser',
  outdatedDataError: 'outdatedDataError',
  notConfirmedDataError: 'notConfirmedDataError',
  issuePermission: 'issuePermission',
};

export const STATE_STATUSES = {
  AVAILABLE: 'AVAILABLE',
  ISSUED: 'ISSUED',
};

export const CB_STATUS_FROM_ESIA = {
  SUCCESS: 'success',
  ERROR: 'error',
  ISSUE_PERMISSION: 'issuePermission',
  REFUSE_PERMISSION_BY_USER: 'refuse_permission_by_user',
  ESIA_SERVER_ERROR: 'esia_server_error',
};

export const RADIO_VALUES = {
  AUTO: 'auto',
  ONCE: 'once',
};

export const REQUIRED_ACTIONS_STATUSES = {
  RENEW: 'renew',
  CONFIRM: 'confirm',
  NONE: 'none',
};
